<template>
      <div class="dynamicQrCodeCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'dynamicQrCode', params: {} }">
          Dynamic Qr Code
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'dynamicQrCodeCreate', params: {} }">
            Create Dynamic Qr Code
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Dynamic Qr Code</v-card-title>
          <v-card-text>
            <dynamicQrCode-form></dynamicQrCode-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import DynamicQrCodeForm from './DynamicQrCodeForm.vue';

    export default {
      name: 'dynamicQrCode',
      components: {
        DynamicQrCodeForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    